module.exports = __webpack_public_path__ + "img/8-last-planner.cad535da.jpg";